
// import React, { useState, useEffect } from 'react';
// import { Doughnut } from 'react-chartjs-2';
// import {
//   Chart as ChartJS,
//   ArcElement,
//   Tooltip,
//   Legend,
// } from 'chart.js';
// import { getStats, getPackages, getUsers, sendNotification } from '../services/api';
// import { useNavigate } from 'react-router-dom';

// // Register Chart.js components
// ChartJS.register(ArcElement, Tooltip, Legend);

// const Dashboard = () => {
//   const [stats, setStats] = useState({});
//   const [recentPackages, setRecentPackages] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [notifications, setNotifications] = useState([]);
//   const [error, setError] = useState(null);
//   const [notifyLoading, setNotifyLoading] = useState({});
//   const role = localStorage.getItem('role');
//   const user_id = parseInt(localStorage.getItem('user_id'));
//   const username = localStorage.getItem('username');
//   const employee_name = localStorage.getItem('employee_name');
//   const navigate = useNavigate();

//   // ADD THIS FUNCTION HERE 👇
//   const handleCardClick = (status) => {
//     navigate('/dashboard/view-packages', {
//       state: { filterStatus: status },
//     });
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         // Validate user_id and role
//         if (!user_id || !role) {
//           setError('Please log in to view the dashboard.');
//           navigate('/login');
//           return;
//         }

//         // Get stats based on role
//         const statsRes = await getStats();
        
//         // Get packages based on role
//         let packagesResponse;
//         try {
//           packagesResponse = await getPackages();
//         } catch (err) {
//           console.error('Error fetching packages:', err);
//           packagesResponse = { data: [] };
//         }

//         // Handle stats response
//         setStats(statsRes.data || {});

//         // Ensure packagesResponse.data is an array
//         const packages = Array.isArray(packagesResponse.data) ? packagesResponse.data : [];
//         console.log('Packages Response:', packages); // Debug log
        
//         // Filter packages based on user role and ID
//         let filteredPackages = packages;
        
//         if (role === 'employee') {
//           // Employee sees only their own packages
//           filteredPackages = packages.filter(pkg => Number(pkg.user_id) === Number(user_id));
// // ... existing code ...
// } else if (role === 'manager') {
//   filteredPackages = packages.filter(pkg => {
//     const isAssignedToMe = !pkg.assigned_approver_id || Number(pkg.assigned_approver_id) === Number(user_id);
    
//     return (
//       (pkg.status === 'pending' && pkg.approver_role === 'manager' && isAssignedToMe) ||
//       pkg.status === 'approved_by_manager' ||
//       pkg.status === 'approved_by_functional_admin' ||
//       pkg.status === 'fully_approved' ||
//       pkg.status === 'rejected_by_manager'
//     );
//   });
// } else if (role === 'functional_admin') {
//   filteredPackages = packages.filter(pkg => {
//     // Direct FA assignment (pending with approver_role = functional_admin)
//     const isDirectFA = pkg.status === 'pending' && pkg.approver_role === 'functional_admin'
//       && (!pkg.assigned_approver_id || Number(pkg.assigned_approver_id) === Number(user_id));
//     return (
//       isDirectFA ||
//       pkg.status === 'approved_by_manager' ||
//       pkg.status === 'approved_by_functional_admin' ||
//       pkg.status === 'fully_approved' ||
//       pkg.status.startsWith('rejected_by_functional_admin')
//     );
//   });
// }
// // ... existing code ...
        
//         setRecentPackages(filteredPackages.slice(0, 5));
        
//         // Set notifications for pending packages that need user's attention
//         const userNotifications = packages.filter((pkg) => {
//           if (role === 'employee') {
//             return pkg.user_id === user_id && pkg.status === 'pending';
//  } else if (role === 'manager') {
//   return (
//     (pkg.status === 'pending' &&
//       pkg.approver_role === 'manager' &&
//       (!pkg.assigned_approver_id ||
//         Number(pkg.assigned_approver_id) === Number(user_id)))
//   );
// }
//  else if (role === 'functional_admin') {
//             // Notify FA for: directly assigned pending packages OR packages approved by manager
//             const isDirectFA = pkg.status === 'pending' && pkg.approver_role === 'functional_admin'
//               && (!pkg.assigned_approver_id || Number(pkg.assigned_approver_id) === Number(user_id));
//             return isDirectFA || pkg.status === 'approved_by_manager';
//           } else if (role === 'super_admin') {
//             return pkg.status === 'pending';
//           }
//           return false;
//         });
        
//         setNotifications(userNotifications);

//         // Fetch users for privileged roles
//         if (['super_admin', 'functional_admin', 'manager'].includes(role)) {
//           const usersRes = await getUsers();
//           setUsers(Array.isArray(usersRes.data) ? usersRes.data : []);
//         }
//       } catch (err) {
//         setError('Failed to load dashboard data. Please try again later.');
//         console.error('Fetch Error:', err.response?.data || err.message);
//         setRecentPackages([]);
//         setNotifications([]);
//         setUsers([]);
//       }
//     };

//     fetchData();
//   }, [user_id, role, navigate]);

//   // Helper: Trigger notification for approved package
//   const handleLocalNotify = async (pkg) => {
//     try {
//       setNotifyLoading((prev) => ({ ...prev, [pkg.reference_id]: true }));
//       if (sendNotification) {
//         await sendNotification({
//           to: [pkg.created_by_email || 'default@yourdomain.com', 'accounts@yourdomain.com'],
//           subject: `Package ${pkg.reference_id} Approved`,
//           message: `Package ${pkg.reference_id} (${pkg.data?.['Package Name'] || 'N/A'}) has been approved.`,
//           packageReference: pkg.reference_id,
//         });
//       }
//       // Update notifications locally
//       setNotifications((prev) => [
//         ...prev,
//         { ...pkg, status: 'notified', timestamp: new Date().toISOString() },
//       ]);
//       alert(`Notification sent for package ${pkg.reference_id}.`);
//     } catch (err) {
//       console.error('Notification Error:', err.response?.data || err.message);
//       alert('Failed to send notification. Please try again.');
//     } finally {
//       setNotifyLoading((prev) => ({ ...prev, [pkg.reference_id]: false }));
//     }
//   };

//   const chartData = {
//     labels: ['Total Packages', 'Pending', 'Approved'],
//     datasets: [
//       {
//         data: [
//           stats.total_packages || 0,
//           stats.pending_packages || 0,
//           stats.fully_approved_packages || 0,
//         ],
//         backgroundColor: ['#1e40af', '#3b82f6', '#10b981'],
//         borderWidth: 1,
//         borderColor: ['#1e3a8a', '#2563eb', '#059669'],
//       },
//     ],
//   };

//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         position: 'right',
//         labels: {
//           font: {
//             size: 14,
//           },
//         },
//       },
//       tooltip: {
//         backgroundColor: '#1f2937',
//         titleFont: { size: 14 },
//         bodyFont: { size: 12 },
//       },
//     },
//   };

//   return (
//     <div className="p-6 bg-gray-50 min-h-screen flex flex-col">
//       {error && (
//         <div className="bg-red-100 text-red-700 p-4 rounded mb-4">{error}</div>
//       )}

 

//       {/* Stats Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
//         {/* Total Packages */}
//         <div
//           onClick={() => handleCardClick('all')}
//           className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow cursor-pointer hover:bg-indigo-50"
//         >
//           <h3 className="text-lg font-semibold text-gray-700 mb-2">
//             Total Packages
//           </h3>
//           <p className="text-4xl font-bold text-indigo-600">
//             {stats.total_packages || 0}
//           </p>
//         </div>

//         {/* Pending */}
//         <div
//           onClick={() => handleCardClick('pending')}
//           className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow cursor-pointer hover:bg-amber-50"
//         >
//           <h3 className="text-lg font-semibold text-gray-700 mb-2">
//             Pending Approval
//           </h3>
//           <p className="text-4xl font-bold text-amber-500">
//             {stats.pending_packages || 0}
//           </p>
//         </div>

//         {/* Approved */}
//         <div
//           onClick={() => handleCardClick('approved')}
//           className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow cursor-pointer hover:bg-green-50"
//         >
//           <h3 className="text-lg font-semibold text-gray-700 mb-2">
//             Approved
//           </h3>
//           <p className="text-4xl font-bold text-green-500">
//             {stats.fully_approved_packages || 0}
//           </p>
//         </div>
//       </div>

//       {/* Notifications */}
//       <div className="bg-white p-6 rounded-xl shadow-md mb-8">
//         <div className="flex justify-between items-center mb-4">
//           <h3 className="text-xl font-semibold text-gray-800">
//             Pending Actions
//           </h3>
//           <span className="bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full">
//             {notifications.length} items
//           </span>
//         </div>
//         <ul className="space-y-3">
//           {notifications.length > 0 ? (
//             notifications.map((notif) => (
//               <li
//                 key={notif.reference_id}
//                 className="p-4 bg-blue-50 border border-blue-200 rounded-md hover:bg-blue-100 cursor-pointer"
//                 onClick={() => handleCardClick('pending')}
//               >
//                 <div className="flex justify-between items-center">
//                   <div>
//                     <p className="font-medium text-gray-800">
//                       Package: {notif.data?.['Package Name'] || 'N/A'} ({notif.reference_id})
//                     </p>
//                     <p className="text-sm text-gray-600 mt-1">
//                       Status: <span className="font-semibold text-amber-600">
//                         {notif.status === 'approved_by_manager'
//                           ? 'Approved by Manager — Awaiting your review'
//                           : `Pending ${notif.approver_role ? notif.approver_role.replace(/_/g, ' ') : 'Approval'}`}
//                       </span>
//                     </p>
//                   </div>
//                   <button
//                     className="text-blue-600 hover:text-blue-800 text-sm font-medium"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       navigate('/dashboard/view-packages', {
//                         state: { package: notif }
//                       });
//                     }}
//                   >
//                     Review →
//                   </button>
//                 </div>
//               </li>
//             ))
//           ) : (
//             <p className="text-gray-600 mt-4 text-center py-4 bg-gray-50 rounded">
//               No pending actions at the moment.
//             </p>
//           )}
//         </ul>
//       </div>

//       {/* Chart */}
//       <div className="bg-white p-6 rounded-xl shadow-md mb-8 h-[400px]">
//         <Doughnut options={chartOptions} data={chartData} />
//       </div>

//       {/* Recent Packages */}
//       <div className="bg-white p-6 rounded-xl shadow-md mb-8">
//         <div className="flex justify-between items-center mb-4">
//           <h3 className="text-xl font-semibold text-gray-800">
//             Recent Packages
//           </h3>
//           <button
//             onClick={() => navigate('/dashboard/view-packages')}
//             className="text-indigo-600 hover:text-indigo-800 text-sm font-medium"
//           >
//             View All →
//           </button>
//         </div>
//         <div className="overflow-x-auto">
//           <table className="min-w-full divide-y divide-gray-200">
//             <thead className="bg-indigo-600">
//               <tr>
//                 <th className="px-6 py-3 text-left text-sm font-semibold text-white">
//                   Reference ID
//                 </th>
//                 <th className="px-6 py-3 text-left text-sm font-semibold text-white">
//                   Package Name
//                 </th>
//                 <th className="px-6 py-3 text-left text-sm font-semibold text-white">
//                   Status
//                 </th>
//                 <th className="px-6 py-3 text-left text-sm font-semibold text-white">
//                   Actions
//                 </th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-200">
//               {recentPackages.length > 0 ? (
//                 recentPackages.map((pkg) => (
//                   <tr
//                     key={pkg.reference_id}
//                     className="hover:bg-gray-50 transition-colors"
//                   >
//                     <td className="px-6 py-4 text-sm text-gray-900">
//                       {pkg.reference_id || 'N/A'}
//                     </td>
//                     <td className="px-6 py-4 text-sm text-gray-900">
//                       {pkg.data?.['Package Name'] || 'N/A'}
//                     </td>
//                     <td className="px-6 py-4 text-sm">
//                       <span className={`px-2 py-1 rounded-full text-xs font-medium ${
//                         pkg.status === 'pending' ? 'bg-amber-100 text-amber-800' :
//                         pkg.status === 'fully_approved' ? 'bg-green-100 text-green-800' :
//                         pkg.status.includes('approved') ? 'bg-blue-100 text-blue-800' :
//                         'bg-red-100 text-red-800'
//                       }`}>
//                         {pkg.status === 'pending' ? 'Pending' :
//                          pkg.status === 'fully_approved' ? 'Approved' :
//                          pkg.status.replace(/_/g, ' ').toUpperCase()}
//                       </span>
//                     </td>
//                     <td className="px-6 py-4 text-sm text-gray-900">
//                       <div className="flex gap-2">
//                         <button
//                           className="bg-indigo-500 hover:bg-indigo-600 text-white px-3 py-1 rounded text-sm"
//                           onClick={() =>
//                             navigate('/dashboard/view-packages', {
//                               state: { package: pkg }
//                             })
//                           }
//                         >
//                           View
//                         </button>
//                         {/* Show Review button if this user can act on this package */}
//                         {(role === 'super_admin' ||
//                           (role === 'manager' && pkg.status === 'pending' && pkg.approver_role === 'manager' && (!pkg.assigned_approver_id || Number(pkg.assigned_approver_id) === Number(user_id))) ||
//                           (role === 'functional_admin' && ['pending', 'approved_by_manager'].includes(pkg.status) && pkg.approver_role === 'functional_admin') ||
//                           (role === 'super_admin' && ['pending','approved_by_manager','approved_by_functional_admin'].includes(pkg.status))
//                         ) && (
//                           <button
//                             className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-sm"
//                             onClick={() => {
//                               navigate('/dashboard/view-packages', {
//                                 state: { package: pkg }
//                               });
//                             }}
//                           >
//                             Review
//                           </button>
//                         )}
//                       </div>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="4" className="px-6 py-4 text-sm text-gray-600 text-center">
//                     No recent packages found.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;
// import React, { useState, useEffect } from 'react';
// import { Doughnut } from 'react-chartjs-2';
// import {
//   Chart as ChartJS,
//   ArcElement,
//   Tooltip,
//   Legend,
// } from 'chart.js';
// import { getStats, getPackages, getUsers, sendNotification } from '../services/api';
// import { useNavigate } from 'react-router-dom';

// // Register Chart.js components
// ChartJS.register(ArcElement, Tooltip, Legend);

// const Dashboard = () => {
//   const [stats, setStats] = useState({});
//   const [recentPackages, setRecentPackages] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [notifications, setNotifications] = useState([]);
//   const [error, setError] = useState(null);
//   const [notifyLoading, setNotifyLoading] = useState({});
//   const role = localStorage.getItem('role');
//   const user_id = parseInt(localStorage.getItem('user_id'));
//   const username = localStorage.getItem('username');
//   const employee_name = localStorage.getItem('employee_name');
//   const navigate = useNavigate();

//   // ADD THIS FUNCTION HERE 👇
//   const handleCardClick = (status) => {
//     navigate('/dashboard/view-packages', {
//       state: { filterStatus: status },
//     });
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         // Validate user_id and role
//         if (!user_id || !role) {
//           setError('Please log in to view the dashboard.');
//           navigate('/login');
//           return;
//         }

//         // Get stats based on role
//         const statsRes = await getStats();
        
//         // Get packages based on role
//         let packagesResponse;
//         try {
//           packagesResponse = await getPackages();
//         } catch (err) {
//           console.error('Error fetching packages:', err);
//           packagesResponse = { data: [] };
//         }

//         // Handle stats response
//         setStats(statsRes.data || {});

//         // Ensure packagesResponse.data is an array
//         const packages = Array.isArray(packagesResponse.data) ? packagesResponse.data : [];
//         console.log('Packages Response:', packages); // Debug log
        
//         // Filter packages based on user role and ID
//         let filteredPackages = packages;
        
//         if (role === 'employee') {
//           // Employee sees only their own packages
//           filteredPackages = packages.filter(pkg => Number(pkg.user_id) === Number(user_id));
// // ... existing code ...
// } else if (role === 'manager') {
//   filteredPackages = packages.filter(pkg => {
//     const isAssignedToMe = !pkg.assigned_approver_id || Number(pkg.assigned_approver_id) === Number(user_id);
    
//     return (
//       (pkg.status === 'pending' && pkg.approver_role === 'manager' && isAssignedToMe) ||
//       pkg.status === 'approved_by_manager' ||
//       pkg.status === 'approved_by_functional_admin' ||
//       pkg.status === 'fully_approved' ||
//       pkg.status === 'rejected_by_manager'
//     );
//   });
// } else if (role === 'functional_admin') {
//   filteredPackages = packages.filter(pkg => {
//     // Direct FA assignment (pending with approver_role = functional_admin)
//     const isDirectFA = pkg.status === 'pending' && pkg.approver_role === 'functional_admin'
//       && (!pkg.assigned_approver_id || Number(pkg.assigned_approver_id) === Number(user_id));
//     return (
//       isDirectFA ||
//       pkg.status === 'approved_by_manager' ||
//       pkg.status === 'approved_by_functional_admin' ||
//       pkg.status === 'fully_approved' ||
//       pkg.status.startsWith('rejected_by_functional_admin')
//     );
//   });
// }
// // ... existing code ...
        
//         setRecentPackages(filteredPackages.slice(0, 5));
        
//         // Set notifications for pending packages that need user's attention
//         const userNotifications = packages.filter((pkg) => {
//           if (role === 'employee') {
//             return pkg.user_id === user_id && pkg.status === 'pending';
//  } else if (role === 'manager') {
//   return (
//     (pkg.status === 'pending' &&
//       pkg.approver_role === 'manager' &&
//       (!pkg.assigned_approver_id ||
//         Number(pkg.assigned_approver_id) === Number(user_id)))
//   );
// }
//  else if (role === 'functional_admin') {
//             // Notify FA for: directly assigned pending packages OR packages approved by manager
//             const isDirectFA = pkg.status === 'pending' && pkg.approver_role === 'functional_admin'
//               && (!pkg.assigned_approver_id || Number(pkg.assigned_approver_id) === Number(user_id));
//             return isDirectFA || pkg.status === 'approved_by_manager';
//           } else if (role === 'super_admin') {
//             return pkg.status === 'pending';
//           }
//           return false;
//         });
        
//         setNotifications(userNotifications);

//         // Fetch users for privileged roles
//         if (['super_admin', 'functional_admin', 'manager'].includes(role)) {
//           const usersRes = await getUsers();
//           setUsers(Array.isArray(usersRes.data) ? usersRes.data : []);
//         }
//       } catch (err) {
//         setError('Failed to load dashboard data. Please try again later.');
//         console.error('Fetch Error:', err.response?.data || err.message);
//         setRecentPackages([]);
//         setNotifications([]);
//         setUsers([]);
//       }
//     };

//     fetchData();
//   }, [user_id, role, navigate]);

//   // Helper: Trigger notification for approved package
//   const handleLocalNotify = async (pkg) => {
//     try {
//       setNotifyLoading((prev) => ({ ...prev, [pkg.reference_id]: true }));
//       if (sendNotification) {
//         await sendNotification({
//           to: [pkg.created_by_email || 'default@yourdomain.com', 'accounts@yourdomain.com'],
//           subject: `Package ${pkg.reference_id} Approved`,
//           message: `Package ${pkg.reference_id} (${pkg.data?.['Package Name'] || 'N/A'}) has been approved.`,
//           packageReference: pkg.reference_id,
//         });
//       }
//       // Update notifications locally
//       setNotifications((prev) => [
//         ...prev,
//         { ...pkg, status: 'notified', timestamp: new Date().toISOString() },
//       ]);
//       alert(`Notification sent for package ${pkg.reference_id}.`);
//     } catch (err) {
//       console.error('Notification Error:', err.response?.data || err.message);
//       alert('Failed to send notification. Please try again.');
//     } finally {
//       setNotifyLoading((prev) => ({ ...prev, [pkg.reference_id]: false }));
//     }
//   };

//   const chartData = {
//     labels: ['Total Packages', 'Pending', 'Approved'],
//     datasets: [
//       {
//         data: [
//           stats.total_packages || 0,
//           stats.pending_packages || 0,
//           stats.fully_approved_packages || 0,
//         ],
//         backgroundColor: ['#1e40af', '#3b82f6', '#10b981'],
//         borderWidth: 1,
//         borderColor: ['#1e3a8a', '#2563eb', '#059669'],
//       },
//     ],
//   };

//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         position: 'right',
//         labels: {
//           font: {
//             size: 14,
//           },
//         },
//       },
//       tooltip: {
//         backgroundColor: '#1f2937',
//         titleFont: { size: 14 },
//         bodyFont: { size: 12 },
//       },
//     },
//   };

//   return (
//     <div className="p-6 bg-gray-50 min-h-screen flex flex-col">
//       {error && (
//         <div className="bg-red-100 text-red-700 p-4 rounded mb-4">{error}</div>
//       )}

 

//       {/* Stats Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
//         {/* Total Packages */}
//         <div
//           onClick={() => handleCardClick('all')}
//           className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow cursor-pointer hover:bg-indigo-50"
//         >
//           <h3 className="text-lg font-semibold text-gray-700 mb-2">
//             Total Packages
//           </h3>
//           <p className="text-4xl font-bold text-indigo-600">
//             {stats.total_packages || 0}
//           </p>
//         </div>

//         {/* Pending */}
//         <div
//           onClick={() => handleCardClick('pending')}
//           className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow cursor-pointer hover:bg-amber-50"
//         >
//           <h3 className="text-lg font-semibold text-gray-700 mb-2">
//             Pending Approval
//           </h3>
//           <p className="text-4xl font-bold text-amber-500">
//             {stats.pending_packages || 0}
//           </p>
//         </div>

//         {/* Approved */}
//         <div
//           onClick={() => handleCardClick('approved')}
//           className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow cursor-pointer hover:bg-green-50"
//         >
//           <h3 className="text-lg font-semibold text-gray-700 mb-2">
//             Approved
//           </h3>
//           <p className="text-4xl font-bold text-green-500">
//             {stats.fully_approved_packages || 0}
//           </p>
//         </div>
//       </div>

//       {/* Notifications */}
//       <div className="bg-white p-6 rounded-xl shadow-md mb-8">
//         <div className="flex justify-between items-center mb-4">
//           <h3 className="text-xl font-semibold text-gray-800">
//             Pending Actions
//           </h3>
//           <span className="bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full">
//             {notifications.length} items
//           </span>
//         </div>
//         <ul className="space-y-3">
//           {notifications.length > 0 ? (
//             notifications.map((notif) => (
//               <li
//                 key={notif.reference_id}
//                 className="p-4 bg-blue-50 border border-blue-200 rounded-md hover:bg-blue-100 cursor-pointer"
//                 onClick={() => handleCardClick('pending')}
//               >
//                 <div className="flex justify-between items-center">
//                   <div>
//                     <p className="font-medium text-gray-800">
//                       Package: {notif.data?.['Package Name'] || 'N/A'} ({notif.reference_id})
//                     </p>
//                     <p className="text-sm text-gray-600 mt-1">
//                       Status: <span className="font-semibold text-amber-600">
//                         {notif.status === 'approved_by_manager'
//                           ? 'Approved by Manager — Awaiting your review'
//                           : `Pending ${notif.approver_role ? notif.approver_role.replace(/_/g, ' ') : 'Approval'}`}
//                       </span>
//                     </p>
//                   </div>
//                   <button
//                     className="text-blue-600 hover:text-blue-800 text-sm font-medium"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       navigate('/dashboard/view-packages', {
//                         state: { package: notif }
//                       });
//                     }}
//                   >
//                     Review →
//                   </button>
//                 </div>
//               </li>
//             ))
//           ) : (
//             <p className="text-gray-600 mt-4 text-center py-4 bg-gray-50 rounded">
//               No pending actions at the moment.
//             </p>
//           )}
//         </ul>
//       </div>

//       {/* Chart */}
//       <div className="bg-white p-6 rounded-xl shadow-md mb-8 h-[400px]">
//         <Doughnut options={chartOptions} data={chartData} />
//       </div>

//       {/* Recent Packages */}
//       <div className="bg-white p-6 rounded-xl shadow-md mb-8">
//         <div className="flex justify-between items-center mb-4">
//           <h3 className="text-xl font-semibold text-gray-800">
//             Recent Packages
//           </h3>
//           <button
//             onClick={() => navigate('/dashboard/view-packages')}
//             className="text-indigo-600 hover:text-indigo-800 text-sm font-medium"
//           >
//             View All →
//           </button>
//         </div>
//         <div className="overflow-x-auto">
//           <table className="min-w-full divide-y divide-gray-200">
//             <thead className="bg-indigo-600">
//               <tr>
//                 <th className="px-6 py-3 text-left text-sm font-semibold text-white">
//                   Reference ID
//                 </th>
//                 <th className="px-6 py-3 text-left text-sm font-semibold text-white">
//                   Package Name
//                 </th>
//                 <th className="px-6 py-3 text-left text-sm font-semibold text-white">
//                   Status
//                 </th>
//                 <th className="px-6 py-3 text-left text-sm font-semibold text-white">
//                   Actions
//                 </th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-200">
//               {recentPackages.length > 0 ? (
//                 recentPackages.map((pkg) => (
//                   <tr
//                     key={pkg.reference_id}
//                     className="hover:bg-gray-50 transition-colors"
//                   >
//                     <td className="px-6 py-4 text-sm text-gray-900">
//                       {pkg.reference_id || 'N/A'}
//                     </td>
//                     <td className="px-6 py-4 text-sm text-gray-900">
//                       {pkg.data?.['Package Name'] || 'N/A'}
//                     </td>
//                     <td className="px-6 py-4 text-sm">
//                       <span className={`px-2 py-1 rounded-full text-xs font-medium ${
//                         pkg.status === 'pending' ? 'bg-amber-100 text-amber-800' :
//                         pkg.status === 'fully_approved' ? 'bg-green-100 text-green-800' :
//                         pkg.status.includes('approved') ? 'bg-blue-100 text-blue-800' :
//                         'bg-red-100 text-red-800'
//                       }`}>
//                         {pkg.status === 'pending' ? 'Pending' :
//                          pkg.status === 'fully_approved' ? 'Approved' :
//                          pkg.status.replace(/_/g, ' ').toUpperCase()}
//                       </span>
//                     </td>
//                     <td className="px-6 py-4 text-sm text-gray-900">
//                       <div className="flex gap-2">
//                         <button
//                           className="bg-indigo-500 hover:bg-indigo-600 text-white px-3 py-1 rounded text-sm"
//                           onClick={() =>
//                             navigate('/dashboard/view-packages', {
//                               state: { package: pkg }
//                             })
//                           }
//                         >
//                           View
//                         </button>
//                         {/* Show Review button if this user can act on this package */}
//                         {(role === 'super_admin' ||
//                           (role === 'manager' && pkg.status === 'pending' && pkg.approver_role === 'manager' && (!pkg.assigned_approver_id || Number(pkg.assigned_approver_id) === Number(user_id))) ||
//                           (role === 'functional_admin' && ['pending', 'approved_by_manager'].includes(pkg.status) && pkg.approver_role === 'functional_admin') ||
//                           (role === 'super_admin' && ['pending','approved_by_manager','approved_by_functional_admin'].includes(pkg.status))
//                         ) && (
//                           <button
//                             className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-sm"
//                             onClick={() => {
//                               navigate('/dashboard/view-packages', {
//                                 state: { package: pkg }
//                               });
//                             }}
//                           >
//                             Review
//                           </button>
//                         )}
//                       </div>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="4" className="px-6 py-4 text-sm text-gray-600 text-center">
//                     No recent packages found.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;
import React, { useState, useEffect } from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { getStats, getPackages, getUsers, sendNotification } from '../services/api';
import { useNavigate } from 'react-router-dom';

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

const Dashboard = () => {
  const [stats, setStats] = useState({});
  const [recentPackages, setRecentPackages] = useState([]);
  const [users, setUsers] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [error, setError] = useState(null);
  const [notifyLoading, setNotifyLoading] = useState({});
  const role = localStorage.getItem('role');
  const user_id = parseInt(localStorage.getItem('user_id'));
  const username = localStorage.getItem('username');
  const employee_name = localStorage.getItem('employee_name');
  const navigate = useNavigate();

  // ADD THIS FUNCTION HERE 👇
  const handleCardClick = (status) => {
    navigate('/dashboard/view-packages', {
      state: { filterStatus: status },
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Validate user_id and role
        if (!user_id || !role) {
          setError('Please log in to view the dashboard.');
          navigate('/login');
          return;
        }

        // Get stats based on role
        const statsRes = await getStats();
        
        // Get packages based on role
        let packagesResponse;
        try {
          packagesResponse = await getPackages();
        } catch (err) {
          console.error('Error fetching packages:', err);
          packagesResponse = { data: [] };
        }

        // Handle stats response
        setStats(statsRes.data || {});

        // Ensure packagesResponse.data is an array
        const packages = Array.isArray(packagesResponse.data) ? packagesResponse.data : [];
        console.log('Packages Response:', packages); // Debug log
        
        // Filter packages based on user role and ID
        let filteredPackages = packages;
        
        if (role === 'employee') {
          filteredPackages = packages.filter(pkg => Number(pkg.user_id) === Number(user_id));
        } else if (role === 'manager') {
          // Manager sees only packages assigned to them (pending or already acted on)
          filteredPackages = packages.filter(pkg => {
            const isMyPending = pkg.status === 'pending' &&
              pkg.approver_role === 'manager' &&
              (!pkg.assigned_approver_id || Number(pkg.assigned_approver_id) === Number(user_id));
            const isMyActioned = Number(pkg.assigned_approver_id) === Number(user_id);
            return isMyPending || isMyActioned;
          });
        } else if (role === 'functional_admin' || role === 'super_admin') {
          // FA and SA see all packages — server already filters by role
          filteredPackages = packages;
        }
        
        setRecentPackages(filteredPackages.slice(0, 5));
        
        // Set notifications for pending packages that need user's attention
        const userNotifications = packages.filter((pkg) => {
          if (role === 'employee') {
            return pkg.user_id === user_id && pkg.status === 'pending';
          } else if (role === 'manager') {
            // Manager notified only for packages pending their specific approval
            return (
              pkg.status === 'pending' &&
              pkg.approver_role === 'manager' &&
              (!pkg.assigned_approver_id || Number(pkg.assigned_approver_id) === Number(user_id))
            );
          } else if (role === 'functional_admin') {
            // FA notified for packages approved by manager (awaiting FA review)
            // or directly assigned pending packages
            const isDirectFA = pkg.status === 'pending' && pkg.approver_role === 'functional_admin';
            return isDirectFA || pkg.status === 'approved_by_manager';
          } else if (role === 'super_admin') {
            return pkg.status === 'pending';
          }
          return false;
        });
        
        setNotifications(userNotifications);

        // Fetch users for privileged roles
        if (['super_admin', 'functional_admin', 'manager'].includes(role)) {
          const usersRes = await getUsers();
          const usersData = usersRes.data?.data || usersRes.data || [];
          const usersList = Array.isArray(usersData) ? usersData : [];
          setUsers(usersList);
          // Inject total_users into stats for super_admin dashboard card
          if (role === 'super_admin') {
            setStats(prev => ({ ...prev, total_users: usersList.length }));
          }
        }
      } catch (err) {
        setError('Failed to load dashboard data. Please try again later.');
        console.error('Fetch Error:', err.response?.data || err.message);
        setRecentPackages([]);
        setNotifications([]);
        setUsers([]);
      }
    };

    fetchData();
  }, [user_id, role, navigate]);

  // Helper: Trigger notification for approved package
  const handleLocalNotify = async (pkg) => {
    try {
      setNotifyLoading((prev) => ({ ...prev, [pkg.reference_id]: true }));
      if (sendNotification) {
        await sendNotification({
          to: [pkg.created_by_email || 'default@yourdomain.com', 'accounts@yourdomain.com'],
          subject: `Package ${pkg.reference_id} Approved`,
          message: `Package ${pkg.reference_id} (${pkg.data?.['Package Name'] || 'N/A'}) has been approved.`,
          packageReference: pkg.reference_id,
        });
      }
      // Update notifications locally
      setNotifications((prev) => [
        ...prev,
        { ...pkg, status: 'notified', timestamp: new Date().toISOString() },
      ]);
      alert(`Notification sent for package ${pkg.reference_id}.`);
    } catch (err) {
      console.error('Notification Error:', err.response?.data || err.message);
      alert('Failed to send notification. Please try again.');
    } finally {
      setNotifyLoading((prev) => ({ ...prev, [pkg.reference_id]: false }));
    }
  };

  const chartData = {
    labels: ['Total Packages', 'Pending', 'Approved'],
    datasets: [
      {
        data: [
          stats.total_packages || 0,
          stats.pending_packages || 0,
          stats.fully_approved_packages || 0,
        ],
        backgroundColor: ['#1e40af', '#3b82f6', '#10b981'],
        borderWidth: 1,
        borderColor: ['#1e3a8a', '#2563eb', '#059669'],
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right',
        labels: {
          font: {
            size: 14,
          },
        },
      },
      tooltip: {
        backgroundColor: '#1f2937',
        titleFont: { size: 14 },
        bodyFont: { size: 12 },
      },
    },
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen flex flex-col">
      {error && (
        <div className="bg-red-100 text-red-700 p-4 rounded mb-4">{error}</div>
      )}

 

      {/* ── Role-based Welcome Banner ─────────────────────────────────── */}
      <div className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl p-6 mb-6 shadow-md">
        <h2 className="text-2xl font-bold">
          {role === 'employee'        && `Welcome, ${employee_name || username} 👋`}
          {role === 'manager'         && `Manager Dashboard — ${employee_name || username}`}
          {role === 'functional_admin'&& `Functional Admin Dashboard — ${employee_name || username}`}
          {role === 'super_admin'     && `Super Admin Dashboard — ${employee_name || username}`}
        </h2>
        <p className="text-indigo-100 text-sm mt-1 capitalize">
          {role?.replace(/_/g, ' ')} · Overview of your package activity
        </p>
      </div>

      {/* ── Role-based Stats Cards ────────────────────────────────────── */}
      {role === 'employee' && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
          <div onClick={() => handleCardClick('all')} className="bg-white p-5 rounded-xl shadow hover:shadow-md cursor-pointer hover:bg-indigo-50 transition-all border-l-4 border-indigo-500">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">My Packages</p>
            <p className="text-4xl font-bold text-indigo-600">{stats.total_packages || 0}</p>
            <p className="text-xs text-gray-400 mt-1">Total submitted</p>
          </div>
          <div onClick={() => handleCardClick('pending')} className="bg-white p-5 rounded-xl shadow hover:shadow-md cursor-pointer hover:bg-amber-50 transition-all border-l-4 border-amber-500">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Pending Approval</p>
            <p className="text-4xl font-bold text-amber-500">{stats.pending_packages || 0}</p>
            <p className="text-xs text-gray-400 mt-1">Awaiting review</p>
          </div>
          <div onClick={() => handleCardClick('approved')} className="bg-white p-5 rounded-xl shadow hover:shadow-md cursor-pointer hover:bg-green-50 transition-all border-l-4 border-green-500">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Fully Approved</p>
            <p className="text-4xl font-bold text-green-600">{stats.fully_approved_packages || 0}</p>
            <p className="text-xs text-gray-400 mt-1">Completed</p>
          </div>
          <div onClick={() => handleCardClick('rejected')} className="bg-white p-5 rounded-xl shadow hover:shadow-md cursor-pointer hover:bg-red-50 transition-all border-l-4 border-red-500">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Rejected</p>
            <p className="text-4xl font-bold text-red-500">{stats.rejected_packages || 0}</p>
            <p className="text-xs text-gray-400 mt-1">Need resubmission</p>
          </div>
        </div>
      )}

      {role === 'manager' && (
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-8">
          <div onClick={() => handleCardClick('all')} className="bg-white p-5 rounded-xl shadow hover:shadow-md cursor-pointer hover:bg-indigo-50 transition-all border-l-4 border-indigo-500">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Total Packages</p>
            <p className="text-4xl font-bold text-indigo-600">{stats.total_packages || 0}</p>
            <p className="text-xs text-gray-400 mt-1">In your queue</p>
          </div>
          <div onClick={() => handleCardClick('pending')} className="bg-white p-5 rounded-xl shadow hover:shadow-md cursor-pointer hover:bg-amber-50 transition-all border-l-4 border-amber-500">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Awaiting My Review</p>
            <p className="text-4xl font-bold text-amber-500">{stats.pending_packages || 0}</p>
            <p className="text-xs text-gray-400 mt-1">Action required</p>
          </div>
          <div onClick={() => handleCardClick('approved')} className="bg-white p-5 rounded-xl shadow hover:shadow-md cursor-pointer hover:bg-blue-50 transition-all border-l-4 border-blue-500">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Approved by Me</p>
            <p className="text-4xl font-bold text-blue-600">{stats.approved_packages || 0}</p>
            <p className="text-xs text-gray-400 mt-1">Passed to next stage</p>
          </div>
          <div onClick={() => handleCardClick('approved')} className="bg-white p-5 rounded-xl shadow hover:shadow-md cursor-pointer hover:bg-green-50 transition-all border-l-4 border-green-500">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Fully Approved</p>
            <p className="text-4xl font-bold text-green-600">{stats.fully_approved_packages || 0}</p>
            <p className="text-xs text-gray-400 mt-1">Completed</p>
          </div>
          <div onClick={() => handleCardClick('rejected')} className="bg-white p-5 rounded-xl shadow hover:shadow-md cursor-pointer hover:bg-red-50 transition-all border-l-4 border-red-500">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Rejected by Me</p>
            <p className="text-4xl font-bold text-red-500">{stats.rejected_packages || 0}</p>
            <p className="text-xs text-gray-400 mt-1">Sent back</p>
          </div>
        </div>
      )}

      {role === 'functional_admin' && (
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-8">
          <div onClick={() => handleCardClick('all')} className="bg-white p-5 rounded-xl shadow hover:shadow-md cursor-pointer hover:bg-indigo-50 transition-all border-l-4 border-indigo-500">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Total Packages</p>
            <p className="text-4xl font-bold text-indigo-600">{stats.total_packages || 0}</p>
            <p className="text-xs text-gray-400 mt-1">Visible to you</p>
          </div>
          <div onClick={() => handleCardClick('pending')} className="bg-white p-5 rounded-xl shadow hover:shadow-md cursor-pointer hover:bg-amber-50 transition-all border-l-4 border-amber-500">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Awaiting FA Review</p>
            <p className="text-4xl font-bold text-amber-500">{stats.pending_packages || 0}</p>
            <p className="text-xs text-gray-400 mt-1">Action required</p>
          </div>
          <div onClick={() => handleCardClick('approved')} className="bg-white p-5 rounded-xl shadow hover:shadow-md cursor-pointer hover:bg-blue-50 transition-all border-l-4 border-blue-500">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">FA Approved</p>
            <p className="text-4xl font-bold text-blue-600">{stats.approved_packages || 0}</p>
            <p className="text-xs text-gray-400 mt-1">Passed to next stage</p>
          </div>
          <div onClick={() => handleCardClick('approved')} className="bg-white p-5 rounded-xl shadow hover:shadow-md cursor-pointer hover:bg-green-50 transition-all border-l-4 border-green-500">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Fully Approved</p>
            <p className="text-4xl font-bold text-green-600">{stats.fully_approved_packages || 0}</p>
            <p className="text-xs text-gray-400 mt-1">Completed</p>
          </div>
          <div onClick={() => handleCardClick('rejected')} className="bg-white p-5 rounded-xl shadow hover:shadow-md cursor-pointer hover:bg-red-50 transition-all border-l-4 border-red-500">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Rejected</p>
            <p className="text-4xl font-bold text-red-500">{stats.rejected_packages || 0}</p>
            <p className="text-xs text-gray-400 mt-1">Sent back</p>
          </div>
        </div>
      )}

      {role === 'super_admin' && (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-8">
          <div onClick={() => handleCardClick('all')} className="bg-white p-5 rounded-xl shadow hover:shadow-md cursor-pointer hover:bg-indigo-50 transition-all border-l-4 border-indigo-500">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Total Packages</p>
            <p className="text-4xl font-bold text-indigo-600">{stats.total_packages || 0}</p>
            <p className="text-xs text-gray-400 mt-1">All packages</p>
          </div>
          <div onClick={() => handleCardClick('pending')} className="bg-white p-5 rounded-xl shadow hover:shadow-md cursor-pointer hover:bg-amber-50 transition-all border-l-4 border-amber-500">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Pending</p>
            <p className="text-4xl font-bold text-amber-500">{stats.pending_packages || 0}</p>
            <p className="text-xs text-gray-400 mt-1">Awaiting action</p>
          </div>
          <div onClick={() => handleCardClick('approved')} className="bg-white p-5 rounded-xl shadow hover:shadow-md cursor-pointer hover:bg-blue-50 transition-all border-l-4 border-blue-500">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">In Progress</p>
            <p className="text-4xl font-bold text-blue-600">{stats.approved_packages || 0}</p>
            <p className="text-xs text-gray-400 mt-1">Partial approvals</p>
          </div>
          <div onClick={() => handleCardClick('approved')} className="bg-white p-5 rounded-xl shadow hover:shadow-md cursor-pointer hover:bg-green-50 transition-all border-l-4 border-green-500">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Fully Approved</p>
            <p className="text-4xl font-bold text-green-600">{stats.fully_approved_packages || 0}</p>
            <p className="text-xs text-gray-400 mt-1">Completed</p>
          </div>
          <div onClick={() => handleCardClick('rejected')} className="bg-white p-5 rounded-xl shadow hover:shadow-md cursor-pointer hover:bg-red-50 transition-all border-l-4 border-red-500">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Rejected</p>
            <p className="text-4xl font-bold text-red-500">{stats.rejected_packages || 0}</p>
            <p className="text-xs text-gray-400 mt-1">Declined</p>
          </div>
          <div className="bg-white p-5 rounded-xl shadow hover:shadow-md transition-all border-l-4 border-purple-500 cursor-default">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Total Users</p>
            <p className="text-4xl font-bold text-purple-600">{stats.total_users || users.length || 0}</p>
            <p className="text-xs text-gray-400 mt-1">Registered accounts</p>
          </div>
        </div>
      )}

      {/* Notifications */}
      <div className="bg-white p-6 rounded-xl shadow-md mb-8">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold text-gray-800">
            Pending Actions
          </h3>
          <span className="bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full">
            {notifications.length} items
          </span>
        </div>
        <ul className="space-y-3">
          {notifications.length > 0 ? (
            notifications.map((notif) => (
              <li
                key={notif.reference_id}
                className="p-4 bg-blue-50 border border-blue-200 rounded-md hover:bg-blue-100 cursor-pointer"
                onClick={() => handleCardClick('pending')}
              >
                <div className="flex justify-between items-center">
                  <div>
                    <p className="font-medium text-gray-800">
                      Package: {notif.data?.['Package Name'] || 'N/A'} ({notif.reference_id})
                    </p>
                    <p className="text-sm text-gray-600 mt-1">
                      Status: <span className="font-semibold text-amber-600">
                        {notif.status === 'approved_by_manager'
                          ? 'Approved by Manager — Awaiting your review'
                          : `Pending ${notif.approver_role ? notif.approver_role.replace(/_/g, ' ') : 'Approval'}`}
                      </span>
                    </p>
                  </div>
                  <button
                    className="text-blue-600 hover:text-blue-800 text-sm font-medium"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate('/dashboard/view-packages', {
                        state: { package: notif }
                      });
                    }}
                  >
                    Review →
                  </button>
                </div>
              </li>
            ))
          ) : (
            <p className="text-gray-600 mt-4 text-center py-4 bg-gray-50 rounded">
              No pending actions at the moment.
            </p>
          )}
        </ul>
      </div>

      {/* Chart */}
      <div className="bg-white p-6 rounded-xl shadow-md mb-8 h-[400px]">
        <Doughnut options={chartOptions} data={chartData} />
      </div>

      {/* Recent Packages */}
      <div className="bg-white p-6 rounded-xl shadow-md mb-8">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold text-gray-800">
            Recent Packages
          </h3>
          <button
            onClick={() => navigate('/dashboard/view-packages')}
            className="text-indigo-600 hover:text-indigo-800 text-sm font-medium"
          >
            View All →
          </button>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-indigo-600">
              <tr>
                <th className="px-6 py-3 text-left text-sm font-semibold text-white">
                  Reference ID
                </th>
                <th className="px-6 py-3 text-left text-sm font-semibold text-white">
                  Package Name
                </th>
                <th className="px-6 py-3 text-left text-sm font-semibold text-white">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-sm font-semibold text-white">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {recentPackages.length > 0 ? (
                recentPackages.map((pkg) => (
                  <tr
                    key={pkg.reference_id}
                    className="hover:bg-gray-50 transition-colors"
                  >
                    <td className="px-6 py-4 text-sm text-gray-900">
                      {pkg.reference_id || 'N/A'}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-900">
                      {pkg.data?.['Package Name'] || 'N/A'}
                    </td>
                    <td className="px-6 py-4 text-sm">
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                        pkg.status === 'pending' ? 'bg-amber-100 text-amber-800' :
                        pkg.status === 'fully_approved' ? 'bg-green-100 text-green-800' :
                        pkg.status.includes('approved') ? 'bg-blue-100 text-blue-800' :
                        'bg-red-100 text-red-800'
                      }`}>
                        {pkg.status === 'pending' ? 'Pending' :
                         pkg.status === 'fully_approved' ? 'Approved' :
                         pkg.status.replace(/_/g, ' ').toUpperCase()}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-900">
                      <div className="flex gap-2">
                        <button
                          className="bg-indigo-500 hover:bg-indigo-600 text-white px-3 py-1 rounded text-sm"
                          onClick={() =>
                            navigate('/dashboard/view-packages', {
                              state: { package: pkg }
                            })
                          }
                        >
                          View
                        </button>
                        {/* Show Review button if this user can act on this package */}
                        {(role === 'super_admin' ||
                          (role === 'manager' && pkg.status === 'pending' && pkg.approver_role === 'manager' && (!pkg.assigned_approver_id || Number(pkg.assigned_approver_id) === Number(user_id))) ||
                          (role === 'functional_admin' && ['pending', 'approved_by_manager'].includes(pkg.status) && pkg.approver_role === 'functional_admin') ||
                          (role === 'super_admin' && ['pending','approved_by_manager','approved_by_functional_admin'].includes(pkg.status))
                        ) && (
                          <button
                            className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-sm"
                            onClick={() => {
                              navigate('/dashboard/view-packages', {
                                state: { package: pkg }
                              });
                            }}
                          >
                            Review
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="px-6 py-4 text-sm text-gray-600 text-center">
                    No recent packages found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;